import { render, staticRenderFns } from "./order-item.vue?vue&type=template&id=44ec6610"
import script from "./order-item.vue?vue&type=script&lang=js"
export * from "./order-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports